<template>
  <article
    class="t-prose prose prose-primary overflow-ellipsis overflow-hidden"
    :class="[classObject, classes]"
  >
    <slot />
  </article>
</template>

<script setup lang="ts">
const props = defineProps({
  classes: {
    type: String,
    default: '',
  },
  responsive: {
    type: Boolean,
    default: true,
  },
  clear: {
    type: Boolean,
    default: true,
  },
  fullWidth: {
    type: Boolean,
    default: true,
  },
})

const classObject = reactive({
  'lg:prose-lg': props.responsive,
  'prose-clear': props.clear,
  'max-w-none': props.fullWidth,
})
</script>
